/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInput,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInput';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePd,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePd';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInput,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInput';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceList,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceList';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInput,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInput';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabel';
import {
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelFromJSON,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelFromJSONTyped,
    JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelToJSON,
} from './JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel';

/**
 * 
 * @export
 * @interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
 */
export interface JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList {
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    nameLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInput}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    seiInput?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInput;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInput}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    meiInput?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInput;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    relationshipLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    relationshipPd?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPd;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    ageLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInput}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    ageInput?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInput;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    pricetypeLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabel;
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    isVisable?: string;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    pricetypePd?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePd;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    agetypeLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePd}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    agetypePd?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePd;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    subsidyNameLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    applicableDateFromLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    applicableDateToLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    receptionDateFromLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    receptionDateToLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabel;
    /**
     * 
     * @type {Array<JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceList>}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    priceList?: Array<JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceList>;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    remainingCountLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    remainingAmountLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    groupRemainingCountLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    groupRemainingAmountLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    applicableDegreeCntLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    personAccompanyNecessityLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    costUnderChargeableNecessityLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabel;
    /**
     * 
     * @type {JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabel}
     * @memberof JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList
     */
    multipleUnusableNecessityLabel?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabel;
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListFromJSON(json: any): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList {
    return JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nameLabel': !exists(json, 'nameLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelFromJSON(json['nameLabel']),
        'seiInput': !exists(json, 'seiInput') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputFromJSON(json['seiInput']),
        'meiInput': !exists(json, 'meiInput') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputFromJSON(json['meiInput']),
        'relationshipLabel': !exists(json, 'relationshipLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelFromJSON(json['relationshipLabel']),
        'relationshipPd': !exists(json, 'relationshipPd') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdFromJSON(json['relationshipPd']),
        'ageLabel': !exists(json, 'ageLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelFromJSON(json['ageLabel']),
        'ageInput': !exists(json, 'ageInput') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputFromJSON(json['ageInput']),
        'pricetypeLabel': !exists(json, 'pricetypeLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelFromJSON(json['pricetypeLabel']),
        'isVisable': !exists(json, 'isVisable') ? undefined : json['isVisable'],
        'pricetypePd': !exists(json, 'pricetypePd') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdFromJSON(json['pricetypePd']),
        'agetypeLabel': !exists(json, 'agetypeLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelFromJSON(json['agetypeLabel']),
        'agetypePd': !exists(json, 'agetypePd') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdFromJSON(json['agetypePd']),
        'subsidyNameLabel': !exists(json, 'subsidyNameLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelFromJSON(json['subsidyNameLabel']),
        'applicableDateFromLabel': !exists(json, 'applicableDateFromLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelFromJSON(json['applicableDateFromLabel']),
        'applicableDateToLabel': !exists(json, 'applicableDateToLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelFromJSON(json['applicableDateToLabel']),
        'receptionDateFromLabel': !exists(json, 'receptionDateFromLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelFromJSON(json['receptionDateFromLabel']),
        'receptionDateToLabel': !exists(json, 'receptionDateToLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelFromJSON(json['receptionDateToLabel']),
        'priceList': !exists(json, 'priceList') ? undefined : ((json['priceList'] as Array<any>).map(JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListFromJSON)),
        'remainingCountLabel': !exists(json, 'remainingCountLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelFromJSON(json['remainingCountLabel']),
        'remainingAmountLabel': !exists(json, 'remainingAmountLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabelFromJSON(json['remainingAmountLabel']),
        'groupRemainingCountLabel': !exists(json, 'groupRemainingCountLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabelFromJSON(json['groupRemainingCountLabel']),
        'groupRemainingAmountLabel': !exists(json, 'groupRemainingAmountLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelFromJSON(json['groupRemainingAmountLabel']),
        'applicableDegreeCntLabel': !exists(json, 'applicableDegreeCntLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelFromJSON(json['applicableDegreeCntLabel']),
        'personAccompanyNecessityLabel': !exists(json, 'personAccompanyNecessityLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelFromJSON(json['personAccompanyNecessityLabel']),
        'costUnderChargeableNecessityLabel': !exists(json, 'costUnderChargeableNecessityLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelFromJSON(json['costUnderChargeableNecessityLabel']),
        'multipleUnusableNecessityLabel': !exists(json, 'multipleUnusableNecessityLabel') ? undefined : JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelFromJSON(json['multipleUnusableNecessityLabel']),
    };
}

export function JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListToJSON(value?: JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nameLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListNameLabelToJSON(value.nameLabel),
        'seiInput': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSeiInputToJSON(value.seiInput),
        'meiInput': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMeiInputToJSON(value.meiInput),
        'relationshipLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipLabelToJSON(value.relationshipLabel),
        'relationshipPd': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListRelationshipPdToJSON(value.relationshipPd),
        'ageLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeLabelToJSON(value.ageLabel),
        'ageInput': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgeInputToJSON(value.ageInput),
        'pricetypeLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPricetypeLabelToJSON(value.pricetypeLabel),
        'isVisable': value.isVisable,
        'pricetypePd': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPricetypePdToJSON(value.pricetypePd),
        'agetypeLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypeLabelToJSON(value.agetypeLabel),
        'agetypePd': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListAgetypePdToJSON(value.agetypePd),
        'subsidyNameLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListSubsidyNameLabelToJSON(value.subsidyNameLabel),
        'applicableDateFromLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateFromLabelToJSON(value.applicableDateFromLabel),
        'applicableDateToLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDateToLabelToJSON(value.applicableDateToLabel),
        'receptionDateFromLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateFromLabelToJSON(value.receptionDateFromLabel),
        'receptionDateToLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListReceptionDateToLabelToJSON(value.receptionDateToLabel),
        'priceList': value.priceList === undefined ? undefined : ((value.priceList as Array<any>).map(JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListPriceListToJSON)),
        'remainingCountLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingCountLabelToJSON(value.remainingCountLabel),
        'remainingAmountLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListRemainingAmountLabelToJSON(value.remainingAmountLabel),
        'groupRemainingCountLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingCountLabelToJSON(value.groupRemainingCountLabel),
        'groupRemainingAmountLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListGroupRemainingAmountLabelToJSON(value.groupRemainingAmountLabel),
        'applicableDegreeCntLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListApplicableDegreeCntLabelToJSON(value.applicableDegreeCntLabel),
        'personAccompanyNecessityLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseV2ScrennDisplayItemListPersonAccompanyNecessityLabelToJSON(value.personAccompanyNecessityLabel),
        'costUnderChargeableNecessityLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListCostUnderChargeableNecessityLabelToJSON(value.costUnderChargeableNecessityLabel),
        'multipleUnusableNecessityLabel': JpCoBenefitoneBsSubsidyDtoAvailableGetResponseScrennDisplayItemListMultipleUnusableNecessityLabelToJSON(value.multipleUnusableNecessityLabel),
    };
}

